<template>
    <b-card>
        <b-form v-on:submit.prevent>
            <b-row>
                <b-col cols="4">
                    <b-form-group
                    label="Organization"
                    label-for="organization"
                    >
                        <v-select
                        id="organization"
                        v-model="form.selectedOrganization"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="text"
                        :options="form.optionsOrganization"
                        placeholder="Select 1 Organization"
                        >
                            <template #search="{attributes, events}">
                                <input
                                class="vs__search"
                                :required="!form.selectedOrganization"
                                v-bind="attributes"
                                v-on="events"
                                />
                            </template>
                        </v-select>
                        <!-- Selected: <strong>{{ form.selectedOrganization }}</strong> -->
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group
                    label="Name"
                    label-for="name"
                    >
                    <b-form-input
                        id="name"
                        placeholder="Name"
                        v-model="form.name"
                        required
                    />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4">
                    <b-form-group
                    label="Village"
                    label-for="village"
                    >
                    <b-form-input
                        id="village"
                        placeholder="Village"
                        v-model="form.village"
                        required
                    />
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group
                    label="District"
                    label-for="district"
                    >
                    <b-form-input
                        id="district"
                        placeholder="District"
                        v-model="form.district"
                        required
                    />
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group
                    label="City"
                    label-for="city"
                    >
                    <b-form-input
                        id="city"
                        placeholder="City"
                        v-model="form.city"
                        required
                    />
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group
                    label="Province"
                    label-for="province"
                    >
                    <b-form-input
                        id="province"
                        placeholder="Province"
                        v-model="form.province"
                        required
                    />
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group
                    label="Country"
                    label-for="country"
                    >
                    <b-form-input
                        id="country"
                        placeholder="Country"
                        v-model="form.country"
                        required
                    />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <b-form-group
                    label="Address"
                    label-for="address"
                    >
                    <b-form-textarea
                        id="address"
                        placeholder="Address"
                        v-model="form.address"
                        required
                    />
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group
                    label="Description"
                    label-for="description"
                    >
                    <b-form-textarea
                        id="description"
                        placeholder="Description"
                        v-model="form.description"
                    />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <!-- submit and reset -->
                <b-col md="12" class="mt-2">
                    <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                    class="mr-1"
                    @click="validation()"
                    >
                    Submit
                    </b-button>
                </b-col>
            </b-row>
        </b-form>
    </b-card>
</template>

<script>
import {
    BFormTextarea, BFormSelect, BListGroupItem, BAvatar, BCard, BCardText, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'

export default {
    components: {
        ToastificationContent,
        vSelect,
        BFormTextarea,
        BFormSelect,
        BListGroupItem,
        BAvatar,
        BCard,
        BCardText,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BForm,
        BButton,
        Prism
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            form: {
                name: '',
                address: '',
                village: '',
                district: '',
                city: '',
                province: '',
                country: '',
                selectedOrganization: null,
                optionsOrganization: [],
                description: ''
            },
            errors: '',
            errMessage: ''
        }
    },
    created() {
        this.getOrganization()
    },
    methods: {
        getOrganization() {
            this.$http.get('organizations/all')
            .then(response => { 
                // console.log(response.data.data)
                var datas = response.data.data
                var i
                for(i=0; i<datas.length; i++) {
                    // console.log(datas[1].children.length === 0)
                    var $data = {
                        value: datas[i].id,
                        text: datas[i].name
                    }
                    // console.log($data)
                    this.form.optionsOrganization.push($data)
                }
                // console.log(this.form.optionsOrganization)
            });
        },
        validation() {
            if(this.form.name === '') {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Name field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.selectedOrganization === null) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Organization field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.address === '') {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Address field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.village === '') {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Village field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.district === '') {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The District field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.city === '') {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The City field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.province === '') {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Province field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.country === '') {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Country field is required',
                        variant: 'warning',
                    },
                })
            } else {
                this.addAssetLocation()
            }
        },
        addAssetLocation() {
            this.$http
            .post("asset/location/add", {
                "name": this.form.name,
                "organization_id": this.form.selectedOrganization.value,
                "address": this.form.address,
                "village": this.form.village,
                "district": this.form.district,
                "city": this.form.city,
                "province": this.form.province,
                "country": this.form.country,
                "description": this.form.description
            })
            .then((response) => {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Success add Asset Location',
                        variant: 'success',
                    },
                })
                location.href = "/asset/asset-locations"
                // console.log(response.data.data)
            }).catch((errors) => {
                this.errMessage = errors.response.data.message
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: this.errMessage,
                        variant: 'warning',
                    },
                })
                console.log(errors.response)
            });
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>